import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listInvites, createInvite, revokeInvite } from '../api/inviteApi';

export const inviteKeys = ['invites'] as const;

export function useInvites() {
  return useQuery({
    queryKey: inviteKeys,
    queryFn: listInvites,
  });
}

export function useCreateInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createInvite,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: inviteKeys }),
  });
}

export function useRevokeInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeInvite,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: inviteKeys }),
  });
}
